import React, { PureComponent } from 'react';
import { connect } from 'unistore/react';

import { monitorActions } from '@utils/store/actions';

class CYTPlaya extends PureComponent {
	constructor(props) {
		super(props);

		this.ytImgIObserver = false;
		this._$ytPlay = React.createRef();
		this.$ytplayMain = React.createRef();
	}

	componentDidMount() {
		if ('IntersectionObserver' in window) {
			this.ytImgIObserver = new IntersectionObserver(
				entries => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							// Stop watching and load the image
							this.ytImgIObserver.unobserve(entry.target);
							entry.target.src = entry.target.dataset.src;
						}
					});
				},
				{
					rootMargin: '50px',
					threshold: 0.01,
				}
			);
		}

		this._loadVideo();
		this.$ytplayMain.current.addEventListener('click', this._playVideo);
	}

	componentWillUnmount() {
		this.$ytplayMain.current.removeEventListener('click', this._playVideo);
	}

	_loadVideo = () => {
		this._source = `https://img.youtube.com/vi/${this.props.vid}/sddefault.jpg`;
		const image = new Image();
		image.setAttribute('data-src', this._source);
		image.alt = 'Check this out';

		this._$ytPlay.current.appendChild(image);

		this.ytImgObserver(
			this._$ytPlay.current.querySelector('img'),
			this._source
		);
	};

	_playVideo = () => {
		const {
			vid,
			start,
			store,
			store: { action },
		} = this.props;
		const iframe = document.createElement('iframe');

		iframe.setAttribute('frameborder', '0');
		iframe.setAttribute('allowfullscreen', '');
		iframe.setAttribute(
			'sandbox',
			'allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-presentation'
		);
		iframe.setAttribute('allow', 'encrypted-media');
		iframe.setAttribute(
			'src',
			`https://www.youtube.com/embed/${vid}?rel=0&showinfo=0&autoplay=1${
				!!start ? `&start=${start}` : ''
			}`
		);
		this._$ytPlay.current.innerHTML = '';
		this._$ytPlay.current.appendChild(iframe);

		action(monitorActions.__pushToMonitorEvents)('Youtube Player', {
			action: `Play me motherfucka!`,
		});
	};

	ytImgObserver = (image, source) => {
		if (!this.ytImgIObserver) {
			image.src = source;
		} else {
			this.ytImgIObserver.observe(image);
		}
	};

	render() {
		return (
			<div
				className={`videoWrapper ${this.props.className || ''}`}
				ref={this.$ytplayMain}
			>
				<div
					className={`c-ytPlay aspect-ratio--object cover ${
						this.props.cinema ? 'c-ytPlay--cinema' : ''
					}`}
					ref={this._$ytPlay}
				>
					<div className="yt__play-button" />
				</div>
			</div>
		);
	}
}

export default connect('')(CYTPlaya);
